<template>
  <v-card class="c-epilogue-card pa-2" elevation="4">
    <v-card-title class="font-italic text-h5 py-2">
        {{ $t('quiz.epilogue') }}
    </v-card-title>

    <v-card-text class="c-epilogue-text">
      <RichText :blocks="quiz.epilogue"/>
    </v-card-text>

  </v-card>
</template>

<script>
import RichText from '@/components/base/RichText'

export default {
  name: 'QuizEpilogueCard',

  components: {
    RichText
  },

  props: {
    quiz: {
      type: Object,
      required: true
    }
  },

  data: function () {
    return {}
  }
}
</script>

<style lang="css" scoped>
.c-epilogue-card {
  width: 100%;
}

.c-epilogue-text {
  font-size: 1.25rem;
  line-height: 2rem;
}
</style>
